import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-entity-header',
    templateUrl: './entity-header.component.html',
    styleUrls: ['./entity-header.component.scss'],
    standalone: false
})
export class EntityHeaderComponent {
    @Input() icon: string = 'person-circle-outline';
    @Input() title: string = '';
    @Input() badgeLabel: string = '';

    /**
     * `default` es el badge lavanda que ya usan los roles (Vendedor, Recepcionista).
     * `warning` es para señalar algo urgente/temporal, como un dato que sólo se ve una vez.
     */
    @Input() badgeVariant: 'default' | 'warning' = 'default';
}
